import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import classNames from 'classnames'

import 'react-toastify/dist/ReactToastify.css'

import { useIsChangingSection } from 'shared/lib/hooks'
import { FlexSpinner } from 'shared/ui/spinner'
import Header from './header'
import Footer from './footer'

export default function Layout() {
  // Blocking data routes (e.g. Browse) keep the current page mounted until
  // their loaders resolve; show the spinner the moment such a navigation starts
  // so the body doesn't sit on the old tab. See useIsChangingSection.
  const isChangingSection = useIsChangingSection()

  return (
    <>
      <div className="flex min-h-screen flex-col">
        <Header />

        <main className="flex flex-grow">
          {isChangingSection ? (
            <FlexSpinner />
          ) : (
            <Suspense fallback={<FlexSpinner />}>
              <Outlet />
            </Suspense>
          )}
        </main>

        <Footer />
      </div>

      <ToastContainer
        className="max-w-prose"
        toastClassName="!rounded-lg"
        bodyClassName="text-base p-3"
        progressClassName={(data) =>
          classNames(data?.defaultClassName, {
            'bg-primary': data?.type === 'default',
          })
        }
        position="bottom-right"
        theme="colored"
        autoClose={5000}
        closeButton={false}
      />
    </>
  )
}
